import { Button } from "@/components/ui/button";
import { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import { cn } from "@/lib/utils";

// Alturas ligadas a la altura de la pantalla para que el teclado nunca desborde
const KEY_HEIGHT = "h-[clamp(2.75rem,9dvh,4.5rem)]";
const KEY_TEXT = "text-[clamp(1.25rem,4dvh,1.875rem)]";

export function Calculator({ total, setChange }) {
  const [given, setGiven] = useState('0');

  useEffect(() => {
    if (given.startsWith('0') && given.length > 1) {
      setGiven(given.substring(1));
    }
    setChange(given - total);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [given]);

  const changeValue = given - total;
  const quick = [5, 10, 20, 50];

  return (
    <div className="flex flex-col gap-2 sm:gap-3">
      <div className="grid grid-cols-2 gap-2 sm:gap-3">
        <div className="text-center bg-white rounded-xl border p-2 sm:p-3">
          <p className="text-neutral-500 text-xs sm:text-sm mb-0.5">Pagar</p>
          <p className="text-neutral-900 font-extrabold leading-tight text-[clamp(1.125rem,3dvh,1.5rem)]">
            {total.toFixed(2)}€
          </p>
        </div>
        <div className="text-center bg-white rounded-xl border p-2 sm:p-3">
          <p className="text-neutral-500 text-xs sm:text-sm mb-0.5">Entregado</p>
          <p className="text-neutral-900 font-extrabold leading-tight text-[clamp(1.125rem,3dvh,1.5rem)]">
            {Number(given).toFixed(2)}€
          </p>
        </div>
      </div>
      <div className="w-full text-center">
        <p className="text-neutral-500 text-xs sm:text-sm">Cambio</p>
        <p
          className={cn(
            "font-extrabold leading-tight text-[clamp(1.5rem,5dvh,2.25rem)]",
            changeValue >= 0 ? "text-green-600" : "text-red-500"
          )}
        >
          {changeValue.toFixed(2)}€
        </p>
      </div>

      <div className="flex gap-1.5 sm:gap-2">
        {quick.map((q) => (
          <Button
            key={q}
            variant="outline"
            className={cn(
              "flex-1 min-w-0 px-1 text-neutral-900 bg-white text-[clamp(0.875rem,2.5dvh,1rem)]",
              KEY_HEIGHT
            )}
            onClick={(e) => { e.stopPropagation(); setGiven(String(q)); }}
          >
            {q}€
          </Button>
        ))}
        <Button
          variant="outline"
          className={cn("flex-1 min-w-0 px-1 text-neutral-900 bg-white text-[clamp(0.875rem,2.5dvh,1rem)]", KEY_HEIGHT)}
          onClick={(e) => { e.stopPropagation(); setGiven('0'); }}
        >
          C
        </Button>
        <Button
          variant="outline"
          className={cn(
            "flex-1 min-w-0 px-1 text-white bg-blue-600 hover:bg-blue-700 font-semibold border-blue-600 text-[clamp(0.875rem,2.5dvh,1rem)]",
            KEY_HEIGHT
          )}
          onClick={(e) => { e.stopPropagation(); setGiven(String(total)); }}
        >
          Exacto
        </Button>
      </div>

      <div className="grid grid-cols-3 gap-1.5 sm:gap-2">
        {new Array(9).fill(1).map((_, index) => (
          <Button
            variant="outline"
            className={cn("text-neutral-900 bg-white font-bold active:scale-95 transition-transform", KEY_HEIGHT, KEY_TEXT)}
            onClick={(e) => { e.stopPropagation(); setGiven(given + String(index + 1)); }}
            key={index}
          >
            {index + 1}
          </Button>
        ))}
        <Button variant="outline" className={cn("text-neutral-900 bg-white font-bold", KEY_HEIGHT, KEY_TEXT)} onClick={(e) => { e.stopPropagation(); setGiven(given + '.'); }}>.</Button>
        <Button variant="outline" className={cn("text-neutral-900 bg-white font-bold", KEY_HEIGHT, KEY_TEXT)} onClick={(e) => { e.stopPropagation(); setGiven(given + '0'); }}>0</Button>
        <Button
          variant="outline"
          className={cn("text-neutral-900 bg-white", KEY_HEIGHT)}
          onClick={(e) => { e.stopPropagation(); setGiven(given.slice(0, -1)); }}
        >
          <Icon icon="mdi:backspace-outline" className="text-[clamp(1.5rem,5dvh,2.25rem)]" />
        </Button>
      </div>
    </div>
  );
}